import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IClimateChangeStructureFormValues,
  ISubcommitteeResponsibilityFormValues,
} from '../../EsgGreenhouseFormProvider/types';

export const SUBCOMMITTEE_REMARK_ID = 'subcommittee-remark';

const ClimateChangeStructureSubcommitteeRemark = () => {
  const { control, getValues } = useGreenhouseForm();

  const { remark } =
    getValues('climateChangeStructure.subcommitteeResponsibility') ??
    ({} as ISubcommitteeResponsibilityFormValues);
  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const remarkEl = document.getElementById(SUBCOMMITTEE_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'climateChangeStructure',
      control,
    }) ?? ({} as IClimateChangeStructureFormValues);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        remarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              topic="ระบุกรรมการชุดย่อยที่มีบทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ"
              fieldPath="climateChangeStructure.subcommitteeResponsibility.remark"
              setOpen={open}
              onDelete={close}
              isCompletedTh={isCompletedTh}
              isCompletedEn={isCompletedEn}
            />
          </Box>,
          remarkEl
        )}
    </>
  );
};

export default ClimateChangeStructureSubcommitteeRemark;
